module.exports = __webpack_public_path__ + "img/Instagram.3c9d09ef.svg";